export const isListNotEmpty = (list: any[]) => list && list.length > 0;
